import React from "react";
import {
  LineChart,
  BarChart3,
  BarChartHorizontal,
  PieChart,
  Hash,
  Target,
  Table2,
} from "lucide-react";

export type WidgetType = "chart" | "scorecard" | "goal" | "grid";
export type ChartKind = "bar" | "column" | "line" | "pie";

export function getChartIcon(
  type: WidgetType,
  chartType: ChartKind,
  className: string = "text-gray-800"
) {
  switch (type) {
    case "chart":
      if (chartType === "bar") return <BarChartHorizontal className={`w-4 h-4 ${className}`} />;
      if (chartType === "column") return <BarChart3 className={`w-4 h-4 ${className}`} />;
      if (chartType === "line") return <LineChart className={`w-4 h-4 ${className}`} />;
      if (chartType === "pie") return <PieChart className={`w-4 h-4 ${className}`} />;
      return null;
    case "scorecard":
      return <Hash className={`w-4 h-4 ${className}`} />;
    case "goal":
      return <Target className={`w-4 h-4 ${className}`} />;
    case "grid":
      return <Table2 className={`w-4 h-4 ${className}`} />;
    default:
      return null;
  }
}

export function getChartText(type: WidgetType, chartType: ChartKind) {
  if (type === "chart") {
    if (chartType === "bar") return "Bar";
    if (chartType === "column") return "Column";
    if (chartType === "line") return "Line";
    if (chartType === "pie") return "Pie";
    return "";
  }
  if (type === "scorecard") return "Number";
  if (type === "goal") return "Goal";
  if (type === "grid") return "Table";
  return "";
}
